import { CalendarIcon, CheckIcon, DocumentIcon } from "@heroicons/react/24/outline";
import {
  AgendaIcon,
  DashboardIcon,
  SettingsIcon,
  StorageIcon,
  TasksIcon,
  type AddEntry,
  type NavEntry,
} from "@ui/layout";
import { ROUTES } from "@shared/routes";

export const PRIMARY: NavEntry[] = [
  { id: ROUTES.home, label: "Tableau de bord", icon: <DashboardIcon /> },
  { id: ROUTES.storage, label: "Mon stockage", icon: <StorageIcon /> },
];

export const SECONDARY: NavEntry[] = [
  { id: ROUTES.agenda, label: "Mon agenda", icon: <AgendaIcon />, disabled: true },
  { id: ROUTES.tasks, label: "Mes tâches", icon: <TasksIcon />, disabled: true },
];

/** Settings sit at the bottom of the column: a destination, not part of the daily flow. */
export const FOOTER: NavEntry[] = [
  { id: ROUTES.settings, label: "Paramètres", icon: <SettingsIcon /> },
];

export const MOBILE_ENTRIES: NavEntry[] = [
  ...PRIMARY,
  ...SECONDARY,
  ...FOOTER,
];

export const ADD_ENTRIES: AddEntry[] = [
  {
    id: "resource",
    label: "Une ressource",
    hint: "Cours, TD, corrigé…",
    icon: <DocumentIcon aria-hidden="true" />,
  },
  {
    id: "task",
    label: "Une tâche",
    hint: "Avec ou sans échéance",
    icon: <CheckIcon aria-hidden="true" />,
    disabled: true,
  },
  {
    id: "event",
    label: "Un événement",
    hint: "Ponctuel ou récurrent",
    icon: <CalendarIcon aria-hidden="true" />,
    disabled: true,
  },
];
